import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "../utils/motion";
import ScrollAnimation from "../components/ScrollAnimation";
import { COUPLES } from "../constants/couples";
import { img } from "../constants/copy";
import { getClientImages } from "../utils/githubService";

export default function CoupleGallery() {
  const { slug } = useParams();
  const couple = COUPLES.find((c) => c.slug === slug);
  const [githubImages, setGithubImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGithubImages = async () => {
      if (!couple) return;
      try {
        setLoading(true);
        const images = await getClientImages(slug);
        setGithubImages(images);
      } catch (error) {
        console.error('Error fetching GitHub images:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchGithubImages();
  }, [slug, couple]);

  if (!couple) {
    return (
      <section className="px-4 sm:px-6 md:px-10 lg:px-16 py-10 sm:py-14 md:py-20">
        
          <p className="text-white font-inter">Couple not found.</p>
          <Link to="/" className="btn-ghost mt-4 inline-block">
            ← Back to Home
          </Link>
  
      </section>
    );
  }

  const { title, images: localImages, quote } = couple;
  // Use GitHub images if available, otherwise fall back to local images
  const displayImages = githubImages.length > 0 
    ? githubImages.map(img => ({ src: img.url, isGithub: true }))
    : localImages.map(src => ({ src: img(src), isGithub: false }));

  const image3DVariants = {
    rest: { scale: 1, rotateY: 0 },
    hover: { 
      scale: 1.05, 
      rotateY: 5,
      transition: { duration: 0.3 }
    }
  };

  return (
    <section className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 py-10 sm:py-14 md:py-20 lg:py-24">
      <div className="max-w-6xl mx-auto">
      
          <Link
            to="/"
            className="btn-ghost mb-6 sm:mb-8 inline-flex items-center gap-2"
          >
            ← Back to Home
          </Link>
          <h1 className="section-heading mb-3 sm:mb-4">{title}</h1>
          {quote && (
            <p className="font-inria font-light italic text-white/85 text-base sm:text-lg md:text-xl max-w-2xl mb-8 sm:mb-10 md:mb-12">
              "{quote}"
            </p>
          )}
   

        {loading ? (
          
            <div className="text-center text-white/70 py-12">
              Loading photos...
            </div>
         
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8">
            {displayImages.map((image, index) => (
            
                <div
                  className="group overflow-hidden rounded-2xl shadow-card card-hover image-3d"
                  variants={image3DVariants}
                  initial="rest"
                  whileHover="hover"
                  style={{ perspective: 1000 }}
                >
                  <img
                    src={image.src}
                    alt={title}
                   
                    decoding="async"
                    className="w-full aspect-[4/5] object-cover img-zoom"
                    onError={(e) => {
                      if (image.isGithub) {
                        e.target.src = img("/Rectangle45.png");
                      }
                    }}
                  />
                </div>
           
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
